import React, { Component } from 'react';
import $ from "jquery";
import DashboardHeading from '../commonFiles/DashboardHeading';
import PersonalContactInformation from './partTimeEmpPages/PersonalContactInformation';
import ProfessionalAcademicCredentials from './partTimeEmpPages/ProfessionalAcademicCredentials';
import EmploymentProfessionalHistory from './partTimeEmpPages/EmploymentProfessionalHistory';
import EngagementTermsWorkScope from './partTimeEmpPages/EngagementTermsWorkScope';
import PaymentRecordsFinancialTransactions from './partTimeEmpPages/PaymentRecordsFinancialTransactions';
class PartTimeEmployee extends Component {
  constructor() {
    super();
    this.state = {
      form_type_list : ['Personal & Contact Information','Professional & Academic Credentials','Employment & Professional History','Engagement Terms & Work Scope','Payment Records & Financial Transactions'],
      form_type_view:[],
      form_view_list:[<PersonalContactInformation page_title="Personal & Contact Information"/>,<ProfessionalAcademicCredentials page_title='Professional & Academic Credentials'/>,<EmploymentProfessionalHistory page_title="Employment & Professional History"/>,<EngagementTermsWorkScope page_title='Engagement Terms &amp; Work Scope'/>,<PaymentRecordsFinancialTransactions page_title='Payment Records &amp; Financial Transactions'/>],
      view_form:'',
    };
  }

componentDidMount(){
  var form_type_view = [];
  var list = this.state.form_type_list;
  for (var i = 0; i < list.length; i++) {
    var for_name = list[i];
    form_type_view.push(
    <option value={for_name}>{for_name}</option>
    );
  }
  this.setState({form_type_view});
}

selectionsFormType(){
  var form_type = $('#form_type').val();
  var form_type_list = this.state.form_type_list;
  var form_view_list = this.state.form_view_list;
  var view_form = '';
  if(form_type_list.includes(form_type)){
    view_form = form_view_list[form_type_list.indexOf(form_type)];
  }else {
    view_form = '';
  }
  this.setState({view_form});
}





  render() {
    return (
        <>
        <DashboardHeading title="Add Employee Details"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h1 className="wow fadeInUp" data-wow-delay="0.1s">Add Part-Time Employee Details</h1>
                <div className="row g-4">

                <div className="col-md-12">
                    <div className="wow fadeInUp" data-wow-delay="0.5s">
                      <div className="row g-3">

                        <div className="col-md-4">
                            <div className="form-floating">
                                <select class="form-control form-select" id="employee_id" name="employee_id">
                                <option value="">Employee List</option>
                            </select>
                            <label for="name">Employee List</label>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-floating">
                                <select class="form-control form-select" id="form_type" name="form_type" onChange={this.selectionsFormType.bind(this)}>
                                <option value="">Employee Form Type</option>
                                {this.state.form_type_view}
                            </select>
                            <label for="name">Employee Form Type</label>
                            </div>
                        </div>

                        

                        </div>
                      </div>
                  </div>

                  {this.state.view_form}


            </div>
        </div>
        {this.state.open_popup}
        </>
    );
  }
}

export default PartTimeEmployee;
